<script setup>
import paymentError from "@/assets/images/payment-error.svg";
defineEmits(["setPopinPanierToListe"]);
</script>
<script>
import LazyImage from "@/components/atoms/lazy-image";
import Container from "@/components/atoms/container";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import { STATUTS_COMMANDE } from "@/utils/statut-commande";

export default {
  name: "OrderError",
  components: {
    LazyImage,
    Container,
    Button,
    ButtonIcon
  },
  data() {
    return {
      statutsCommande: STATUTS_COMMANDE
    };
  },
  props: {
    statut: {
      type: String,
      required: true
    },
    typePanier: {
      type: String,
      required: false,
      default: "drive"
    }
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
    class="u-bgcolor-white u-text-center u-pb-xxlg"
  >
    <Container>
      <div class="u-flex u-flex-justify-center u-pt-xlg">
        <LazyImage
          :src="paymentError"
          width="125"
          height="81"
        />
      </div>

      <h1 class="u-font-24 u-color-primary u-mt-sm">
        <template v-if="statut == statutsCommande.annulee">
          Paiement annulé
        </template>
        <template v-if="statut == statutsCommande.refusee">
          Paiement refusé
        </template>
        <template v-if="statut == statutsCommande.erreur">
          Erreur technique
        </template>
      </h1>

      <p class="u-font-15 u-mt-sm">
        <template v-if="statut == statutsCommande.annulee">
          Votre commande n’a pas été prise en compte car votre paiement a été annulé.
        </template>
        <template v-if="statut == statutsCommande.refusee">
          Votre commande n’a pas été prise en compte car votre paiement a été refusé.
        </template>
        <template v-if="statut == statutsCommande.erreur">
          Votre commande n’a pas été prise en compte car une erreur technique est survenue.
        </template>
      </p>

      <p class="u-font-15 u-pb-lg u-mt-xs">
        Votre panier a été conservé. Vous pouvez l’enregistrer en liste pour ré-essayer plus tard
      </p>

      <div class="u-flex u-flex-column u-mt-lg">
        <p class="u-mb-md">
          <Button
            variant="secondary"
            radius="full"
            size="md"
            :to="`/panier?type_panier=${typePanier}`"
          >
            Retour au panier
          </Button>
        </p>
        <p>
          <ButtonIcon
            icon-name="list"
            icon-color="primary"
            icon-color-hover="white"
            size="md"
            outline
            radius="full"
            variant="primary"
            @click="$emit('setPopinPanierToListe')"
          >
            Mettre de côté dans une liste
          </ButtonIcon>
        </p>
      </div>
    </Container>
  </div>
</template>
